import { render } from "./user.vue?vue&type=template&id=3065945e"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__